import React from "react";
import { Container } from "react-bootstrap";
import PdfViewerCard from "../../PdfViewerCard";
import "../../incidentes.css";

const PythonTema3 = () => {
  const pdfUrl = `${process.env.REACT_APP_BUCKET}/pdf/Tema3_Programacion_Basica.pdf`;
  /*const pdfUrl = "/pdf/Tema3_Programacion_Basica.pdf";*/

  return (
    <>
      <Container fluid className="background-containerr">
        <div className="orgproc-header">
          <h1 className="orgproc-heading">Tema 3: Programación Básica</h1>
        </div>
        <PdfViewerCard pdfUrl={pdfUrl} titulo="Tema 3: Programación Básica" />
      </Container>
    </>
  );
};

 export default PythonTema3;
